import React from 'react';
import ReactDom from 'react-dom';
// import injectTapEventPlugin from 'react-tap-event-plugin/injectTapEventPlugin';
//import {Container} from 'main/container'
import { App } from 'js/app';
import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';

import '@babel/polyfill';

let getJson = function() {
  let promise = new Promise(function(resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open(
      'GET',
      'https://napsg-web.s3.amazonaws.com/symbology/napsg_symbology_v4.1.5.json'
    );
    xhr.send(null);

    xhr.onreadystatechange = function() {
      let json = {};
      if (xhr.readyState === 4) {
        if (xhr.statusText === 'OK') {
          json = JSON.parse(xhr.response);

          resolve(json);
        } else if (xhr.statusText === 'Not Found') {
          reject();
        }
      }
    };
  });

  return promise;
};

let loadapp = function() {
  // injectTapEventPlugin();
  ReactDom.render(<App />, document.getElementById('root'));
};

getJson().then(function(response) {
  subCategoryActions.updateSymbologyJson(response);
  loadapp();
});



// WEBPACK FOOTER //
// ./src/loader.js